import { i18n } from "../utils/i18n";
import animateCSS from "../utils/animateCSS";

const defaultModalAnimations = "fadeInDown, fadeOutUp";

export const closeModal = (modal: HTMLElement) => {
  hideOverlay();
  const animation = (modal.dataset.animations ?? defaultModalAnimations).split(
    ", "
  )[1];
  const modalContent = modal.querySelector<HTMLElement>(".modal-content");

  if (modalContent === null) return;

  animateCSS(modalContent, animation).then(() => {
    modal.classList.remove("active");
  });
};

export const showModal = (modal: HTMLElement) => {
  showOverlay();
  modal.classList.add("active");
  const animation = (modal.dataset.animations ?? defaultModalAnimations).split(
    ", "
  )[0];
  const modalContent = modal.querySelector<HTMLElement>(".modal-content");
  if (modalContent === null) return;

  animateCSS(modalContent, animation);
};

export const createConfirmationModal = ({
  content,
  title,
  okButton,
  okButtonClass,
  onConfirm,
  onClose
}): HTMLDivElement => {
  let modal = document.querySelector<HTMLDivElement>("#deleteMultipleModal");

  const modalHtml = `
    <div class="modal-dialog modal-dialog_centered max-w-2xl">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">${title}</h2>
          <button type="button" class="close la la-times" data-dismiss="modal"></button>
        </div>
        <div class="modal-body">
        ${content}
        </div>
        <div class="modal-footer">
          <div class="flex ltr:ml-auto rtl:mr-auto">
            <button type="button" class="btn btn_secondary uppercase" data-dismiss="modal" data-testid="modal_cancel_button">${i18n.t(
              "actions.cancel"
            )}</button>
            <button type="button" data-confirm="form" data-testid="modal_ok_button" class="btn ${okButtonClass} ltr:ml-2 rtl:mr-2 uppercase">${okButton}</button>
          </div>
        </div>
      </div>
    </div>`;

  if (!modal) {
    modal = document.createElement("div");
    modal.id = "deleteMultipleModal";
    modal.classList.add("modal");
    modal.dataset.animations = "fadeInDown, fadeOutUp";
    document.body.append(modal);
    modal.querySelectorAll('[data-dismiss="modal"]');
  }

  modal.innerHTML = modalHtml;

  const handleClose = () => {
    closeModal(modal as HTMLElement);
    if (onClose) {
      onClose();
    }
  };
  modal.querySelectorAll('[data-dismiss="modal"]').forEach((element) => {
    element.addEventListener("click", handleClose);
  });
  modal.querySelectorAll('[data-confirm="form"]').forEach((element) => {
    element.addEventListener("click", onConfirm);
  });

  return modal;
};

export const showOverlay = (workspace = false) => {
  let overlay = document.querySelector(".overlay");
  if (overlay) return overlay;

  document.body.classList.add("overlay-show");

  overlay = document.createElement("div");
  if (workspace) {
    overlay.setAttribute("class", "overlay overlay_workspace");
  } else {
    overlay.setAttribute("class", "overlay");
  }

  document.body.appendChild(overlay);
  overlay.classList.add("active");

  return overlay;
};

export const hideOverlay = () => {
  const overlayToRemove = document.querySelector(".overlay");

  if (!overlayToRemove) return;

  document.body.classList.remove("overlay-show");

  overlayToRemove.classList.remove("active");
  document.body.removeChild(overlayToRemove);
};
